// react-native-google-places-autocomplete switches itself off on the web unless
// it gets a `requestUrl`. Point it at Google as usual: shims/google-api.js then
// routes the requests through the same-origin proxy.
import React, {forwardRef} from 'react';
import {GooglePlacesAutocomplete as Base} from 'react-native-google-places-autocomplete/GooglePlacesAutocomplete';

const REQUEST_URL = {
  useOnPlatform: 'web',
  url: 'https://maps.googleapis.com/maps/api',
};

export const GooglePlacesAutocomplete = forwardRef(
  function GooglePlacesAutocomplete(props, ref) {
    return <Base ref={ref} requestUrl={REQUEST_URL} {...props} />;
  },
);

export default GooglePlacesAutocomplete;
